import React, { useState, useEffect } from "react";
import {
  Col,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner
} from "reactstrap";
import { connect } from "react-redux";
import SegurancaInfo from "../usuario/perfil/seguranca_info";
import Historico from "../usuario/perfil/historico";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import {
  updateProfile,
  uploadProfilePhoto
} from "../../providers/userProvider";
import Toast from "../utils/Toast";
import {
  faUserCircle,
  faChevronDown,
  faBell,
  faComments
} from "@fortawesome/free-solid-svg-icons";
import "./professionalInfo.css";

const tabs = {
  infos: 0,
  notifications: 1,
  history: 2,
  security: 3
};

const fields = {
  email: 1,
  name: 2
};

const MyAccount = ({
  user,
  toProfessionalInfo,
  updateLoading,
  doUpdatePersonalAccount,
  successMessage,
  errorMessage
}) => {

  const [activeTab, setActiveTab] = useState(tabs.infos);
  const [email, setEmail] = useState("");
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [taxPayer, setTaxPayer] = useState("");
  const [photo, setPhoto] = useState("");
  //const [has_completed_profile, setHasCompletedProfile] = useState(true);
  //const [complete_profile_modal, setCompleteProfileModal] = useState(false);
  const [editing, setEditing] = useState(null);

  const setInfos = () => {
    setEmail(user.email);
    setFirstName(user.firstName);
    setLastName(user.lastName);
    setPhoto(user.profilePhoto);
    setTaxPayer(user.taxPayer);
    //setHasCompletedProfile(user.profile.completed);
  };

  useEffect(() => setInfos(), []);
  useEffect(() => setInfos(), [user]);

  /* const toggleCompleteProfileModal = () => {
        setCompleteProfileModal(!complete_profile_modal);
    }; */

  const handleEditButton = value => {
    setEditing(value);
  };

  const saveChanges = async () => {
    const changes = {
      email,
      firstName: first_name,
      lastName: last_name,
      taxPayer
    };
    await doUpdatePersonalAccount(
      user._id,
      user.token,
      changes,
      user.isProfessional
    );
  };

  const uploadPicture = async e => {
    const picture = e.target.files[0];
    console.log(picture);

    if (!picture) return;

    const result = await uploadProfilePhoto(picture, user._id, user.token);
    if (result.error) {
      console.log(result);
      return;
    }
    console.log(result);
    setPhoto(result.profilePhoto);
  };

  const renderInfos = () => {
    return (
      <div>
        <h4>Informações pessoais</h4>
        <div className="mt-3">
          <div className="image-input-container">
            <Label className="image-label" htmlFor="image-input">
              {photo ? (
                <img src={photo} className="profile-avatar" />
              ) : (
                <FontAwesomeIcon
                  icon={faUserCircle}
                  color="#267e96"
                  className="profile-icon"
                />
              )}
              Escolha uma foto
            </Label>
            <Input
              id="image-input"
              type="file"
              accept="image/png, image/jpg"
              onChange={uploadPicture}
            />
          </div>
          <div className="edit-container">
            <p style={{ fontWeight: 350 }}>EMAIL</p>
            <button
              className="edit-icon-button"
              onClick={() => handleEditButton(fields.email)}
            >
              <FontAwesomeIcon
                icon={faPencilAlt}
                color="#25313B"
                transform="shrink-4 left-8 up-4"
              />
            </button>
          </div>
          {editing === fields.email ? (
            <Label className="w-100">
              <Input value={email} onChange={e => setEmail(e.target.value)} />
            </Label>
          ) : (
            <p>{email}</p>
          )}
        </div>
        <div>
          <div className="edit-container">
            <p style={{ fontWeight: 350 }}>GERAL</p>
            <button
              className="edit-icon-button"
              onClick={() => handleEditButton(fields.name)}
            >
              <FontAwesomeIcon
                icon={faPencilAlt}
                color="#25313B"
                transform="shrink-4 left-8 up-4"
              />
            </button>
          </div>
          <div>
            {editing === fields.name ? (
              <div>
                <div className="d-flex">
                  <Label className="w-50 mr-3">
                    Primeiro Nome
                    <Input
                      value={first_name}
                      onChange={e => setFirstName(e.target.value)}
                    />
                  </Label>
                  <Label className="w-50">
                    Último Nome
                    <Input
                      value={last_name}
                      onChange={e => setLastName(e.target.value)}
                    />
                  </Label>
                </div>
                <Label className="w-50">
                  CPF
                  <Input
                    value={taxPayer}
                    onChange={e => setTaxPayer(e.target.value)}
                  />
                </Label>
              </div>
            ) : (
              <div>
                <span
                  style={{
                    fontWeight: 250,
                    fontSize: 16,
                    flexDirection: "row"
                  }}
                >
                  <b>{`Nome completo: `}</b>
                  {`${first_name}  ${last_name}`}
                </span>
                <div style={{ fontWeight: 250, fontSize: 16 }}>
                  <b>{`CPF: `}</b>
                  {`${taxPayer}`}
                </div>
              </div>
            )}
          </div>
        </div>
        {editing ? (
          <Button onClick={saveChanges} className="submit-btn mb-0">
            {updateLoading ? <Spinner color="light" size="sm" /> : "Salvar"}
          </Button>
        ) : null}
        {successMessage ? (
          <Toast message={successMessage} type="success" />
        ) : null}
        {errorMessage ? <Toast message={errorMessage} type="error" /> : null}
      </div>
    );
  };

  const renderNotifications = () => {
    return (
      <div>
        <h3>Notificações e alertas</h3>
        <Form>
          <FormGroup check>
            <Label check>
              <Input type="checkbox" />
              Receber um e-mail quando um profissional com quem já me consultei
              estiver online.
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input type="checkbox" />
              Receber notificação cada vez que receber mensagem de um consultor.
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input type="checkbox" />
              Receber um e-mail diariamente com os novos consultores da
              plataforma.
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input type="checkbox" />
              Receber um e-mail com novidades sobre a plataforma.
            </Label>
          </FormGroup>
        </Form>
      </div>
    );
  };

  const renderContent = () => {
    switch (activeTab) {
      case tabs.infos:
        return renderInfos();
      case tabs.notifications:
        return renderNotifications();
      case tabs.security:
        return <SegurancaInfo />;
      case tabs.history:
        return <Historico user={user} />;
    }
  };

  const isActive = tab => {
    let className = null;
    if (tab === activeTab) {
      className = "active";
    }
    return className;
  };

  return (
    <div className="col-md-12">
      {/* !has_completed_profile && user.profile.is_professional ? 
                (
                <Modal isOpen={!complete_profile_modal} toggle={toggleCompleteProfileModal}>
                    <ModalHeader>Opa! Você precisa completar seu perfil</ModalHeader>
                    <ModalBody>
                        Para poder utilizar completamente nosso serviço você precisa adicionar algumas informações no seu perfil.
                    </ModalBody>
                    <ModalFooter>
                        <Button 
                            style={{backgroundColor: "#FF7C34", border: "none"}} 
                            onClick={() => toProfessionalInfo()}>Completar perfil
                        </Button>{' '}
                        <Button 
                            color=""
                            onClick={toggleCompleteProfileModal}>Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
                ) : null
             */}
      <div className="mt-4">
        <h2 id="tipo-texto">Minha Conta</h2>
      </div>
      <Nav className="nav-account-content">
        <NavItem>
          <NavLink
            className={isActive(tabs.infos)}
            href="#"
            onClick={() => setActiveTab(tabs.infos)}
          >
            Informações pessoais
          </NavLink>
        </NavItem>
        {/* <NavItem>
          <NavLink
            className={isActive(tabs.notifications)}
            href="#"
            onClick={() => setActiveTab(tabs.notifications)}
          >
            Notificações e alertas
          </NavLink>
        </NavItem> */}
        <NavItem>
          <NavLink
            className={isActive(tabs.history)}
            href="#"
            onClick={() => setActiveTab(tabs.history)}
          >
            Histórico
          </NavLink>
        </NavItem>
        {/* <NavItem>
          <NavLink
            className={isActive(tabs.security)}
            href="#"
            onClick={() => setActiveTab(tabs.security)}
          >
            Segurança
          </NavLink>
        </NavItem> */}
      </Nav>
      <div>
        <div className="profile-card">{renderContent()}</div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    user: state.user.userInfo,
    successMessage: state.user.updateAccountSuccessMsg,
    errorMessage: state.user.updateAccountError,
    updateLoading: state.user.updateLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    doUpdatePersonalAccount: (id, token, changes, isProfessional) =>
      dispatch(updateProfile(id, token, changes, isProfessional))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount);
